import templateUrl from "emun.cart/cart-item-quick-view-options.htm";

export default () => ({
  templateUrl
});
